import React from 'react';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { useStyles } from './styles.js';

const EventClosed = props => {
  const { classes } = props;
  return (
    <Grid className={classes.eventClosed}>
      <h1 className={classes.secTitle}>Event has closed!</h1>
    </Grid>
  );
};

export default withStyles(useStyles)(EventClosed);
